import React, {
  useCallback,
  useState,
  useMemo,
  useImperativeHandle,
} from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import PeriodRenderComponent, {
  checkMoreThanOneYear,
} from '../../../ReportBuilder/Components/SectionPeriod/PeriodRenderComponent';
import { FeedbackQuestionHandler, FeedbackSectionInfo } from '../utils';
import {
  ParentPeriodValue,
  parsePeriodValues,
} from '../../../ReportBuilder/Components/SectionPeriod/utils';
import { capitalizeFirstLetter } from 'shared/utils/stringUtils';
import { formattedDate } from 'shared/utils/date';
import { FeedbackQuestionsById } from '../api';

const StyledDiv = styled.div``;

const PeriodSection = React.forwardRef<
  FeedbackQuestionHandler,
  FeedbackSectionInfo
>(
  (
    { reportId, questionId, questionText, answer, question, questions },
    forwardRef,
  ) => {
    const options = useMemo(() => question.enumResponses.map(x => x.response), [
      question,
    ]);
    const period = parsePeriodValues(answer, options);
    const [value, setValue] = useState<ParentPeriodValue | null>({
      option: period.card || '',
      startDate: formattedDate(period.startDate),
      endDate: formattedDate(period.endDate),
    });

    const handleChange = useCallback(
      (questionId: number, value: ParentPeriodValue | null) => {
        setValue(value);
      },
      [setValue],
    );

    useImperativeHandle(forwardRef, () => ({
      reportId,
      questionId,
      answer: () =>
        value && value.startDate && value.endDate
          ? `${capitalizeFirstLetter(value.option)}: ${formattedDate(
              value.startDate,
            )} - ${formattedDate(value.endDate)}`
          : '',
      errorText: () =>
        value ? undefined : 'Please pick a valid start and end date.',
    }));

    return (
      <StyledDiv>
        <TrueImpactText variant="heading-subheading" className="question-text">
          {questionText}
        </TrueImpactText>
        <PeriodRenderComponent
          reportId={reportId}
          isThirdParty={false}
          onChange={handleChange}
          options={options}
          questionId={questionId}
          value={value}
          isMoreThanOneYear={checkMoreThanOneYear(
            questions[10004]?.answers?.[0]?.text,
          )}
        />
      </StyledDiv>
    );
  },
);

export default PeriodSection;
